import { render, staticRenderFns } from "./DashboardClassificator.vue?vue&type=template&id=c5a80022&scoped=true"
import script from "./DashboardClassificator.vue?vue&type=script&lang=js"
export * from "./DashboardClassificator.vue?vue&type=script&lang=js"
import style0 from "./DashboardClassificator.vue?vue&type=style&index=0&id=c5a80022&prod&lang=scss&scoped=true"
import style1 from "./DashboardClassificator.vue?vue&type=style&index=1&id=c5a80022&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a80022",
  null
  
)

export default component.exports